"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const common_components_1 = require("@zapier/common-components");
const design_system_patterns_1 = require("@zapier/design-system-patterns");
const ServiceIcon = ({ borderColor = 'grey200', borderWidth = 1, isInGroup, serviceName, size, shadow, }) => {
    const iconSize = Math.ceil(0.7 * size);
    return (react_1.default.createElement(design_system_patterns_1.ServiceIconShell, { borderColor: borderColor, borderWidth: borderWidth, height: size, isInGroup: isInGroup, shadow: shadow, width: size },
        react_1.default.createElement(common_components_1.LogoImage, { app: serviceName, size: iconSize })));
};
exports.default = ServiceIcon;
